module.exports = __webpack_public_path__ + "assets/img/imgbig_yhqh.9a0b96b1.jpg";